import store from '../../store'

const PortalLayout = () => import('@/components/modules/portal/PortalLayout')
const PortalLogin = () => import('@/components/modules/portal/PortalLogin')
const PortalChangePassword = () => import('@/components/modules/portal/PortalChangePassword')
const PortalCompanySelect = () => import('@/components/modules/portal/PortalCompanySelect')
const PortalDashboard = () => import('@/components/modules/portal/PortalDashboard')
const PortalDocuments = () => import('@/components/modules/portal/PortalDocuments')
const PortalNotifications = () => import('@/components/modules/portal/PortalNotifications')
const PortalProfile = () => import('@/components/modules/portal/PortalProfile')
const PortalProjects = () => import('@/components/modules/portal/PortalProjects')
const PortalProjectItems = () => import('@/components/modules/portal/PortalProjectItems')
const PortalItemDetail = () => import('@/components/modules/portal/PortalItemDetail')

function ifPortalNotAuthenticated(to, from, next) {
	// Un token in query è un accesso da "Accedi come utente": deve entrare nella pagina
	// di login anche con una sessione portale già presente. Altrimenti la guardia
	// reindirizza prima che il componente sia montato, autoLogin() non parte mai e il
	// token viene scartato in silenzio: si resta loggati come l'utente precedente, e
	// si finisce sulla schermata di cambio password (o su un errore di utente
	// disabilitato) che appartiene a quella vecchia sessione, non a chi si voleva
	// impersonare.
	if (to.query.token) {
		next()
		return
	}
	if (!store.getters.isPortalAuthenticated) {
		next()
		return
	}
	if (store.getters.portalForcePasswordChange) {
		next('/portal/change-password')
		return
	}
	if (store.getters.portalNeedsCompanySelection) {
		next('/portal/select-company')
		return
	}
	next('/portal')
}

function ifPortalAuthenticated(to, from, next) {
	if (store.getters.isPortalAuthenticated) {
		if (store.getters.portalForcePasswordChange && to.name !== 'portal-change-password') {
			next('/portal/change-password')
			return
		}
		if (store.getters.portalNeedsCompanySelection && to.name !== 'portal-select-company') {
			next('/portal/select-company')
			return
		}
		next()
		return
	}
	next('/portal/login')
}

function ifPortalAuthenticatedForcePassword(to, from, next) {
	if (store.getters.isPortalAuthenticated) {
		next()
		return
	}
	next('/portal/login')
}

export const portal = [
	{
		path: '/portal/login',
		name: 'portal-login',
		component: PortalLogin,
		beforeEnter: ifPortalNotAuthenticated,
		meta: { portal: true, title: 'Login Area Privata' }
	},
	{
		path: '/portal/change-password',
		name: 'portal-change-password',
		component: PortalChangePassword,
		beforeEnter: ifPortalAuthenticatedForcePassword,
		meta: { portal: true, title: 'Cambio Password' }
	},
	{
		path: '/portal/select-company',
		name: 'portal-select-company',
		component: PortalCompanySelect,
		beforeEnter: ifPortalAuthenticated,
		meta: { portal: true, title: 'Seleziona Azienda' }
	},
	{
		path: '/portal',
		component: PortalLayout,
		beforeEnter: ifPortalAuthenticated,
		meta: { portal: true },
		children: [
			{
				path: '',
				name: 'portal-dashboard',
				component: PortalDashboard,
				meta: { portal: true, title: 'Dashboard' }
			},
			{
				path: 'documents',
				name: 'portal-documents',
				component: PortalDocuments,
				meta: { portal: true, title: 'Documenti' }
			},
			{
				path: 'projects',
				name: 'portal-projects',
				component: PortalProjects,
				meta: { portal: true, title: 'Progetti' }
			},
			{
				path: 'projects/:id',
				name: 'portal-project-items',
				component: PortalProjectItems,
				meta: { portal: true, title: 'Segnalazioni' }
			},
			{
				path: 'items/:id',
				name: 'portal-item-detail',
				component: PortalItemDetail,
				meta: { portal: true, title: 'Segnalazione' }
			},
			{
				path: 'documents/folder/:folderId',
				name: 'portal-documents-folder',
				component: PortalDocuments,
				meta: { portal: true, title: 'Documenti' }
			},
			{
				path: 'notifications',
				name: 'portal-notifications',
				component: PortalNotifications,
				meta: { portal: true, title: 'Notifiche' }
			},
			{
				path: 'profile',
				name: 'portal-profile',
				component: PortalProfile,
				meta: { portal: true, title: 'Profilo' }
			}
		]
	}
]
